import { DatePicker, Form, Input, Select, Spin } from "antd";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { activityOptions, GenderData, YesNoData } from "../../../../data";
import svg92 from "../../../../assets/svg/svg92.svg";
import svg85 from "../../../../assets/svg/svg85.svg";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { setActiveObj } from "../../../../features/folder/folderSlice";

const { TextArea } = Input;
function ActivityDetails({ handleNext, handleBack, form }) {
  const urlJob = "api/v1/jobs/getAll";
  const { dataJob } = useSelector((state) => ({
    dataJob: state.dropdown.data[urlJob] || [],
  }));
  const { activeObjActivity } = useSelector((state) => ({
    activeObjActivity: state.folder.activeObj["activity"],
  }));
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlePrev = async () => {
    await navigate("/recruitment/activity-list");
  };

  async function handleSubmitStep() {
    try {
      const values = await form.validateFields();
      const res = await dispatch(
        save({
          url: "api/v1/activities/create",
          jaaId: activeObjActivity?.jaaId ?? null,
          ...values,
        })
      );

      if (res?.payload?.success) {
        await toast.success(res.payload.messages.message);
        await dispatch(
          setActiveObj({ key: "activity", data: res?.payload?.data?.result })
        );
        await handleNext();
      } else {
        toast.error(res.payload?.messages?.message);
      }
    } catch (error) {
      console.log("Error in saving form:", error);
    }
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlJob,
        limit: null,
        start: 0,
        statuses: null,
      })
    );
  }, []);

  return (
    <>
      <div className="text-lightBlack text-[1.5rem] font-dmSans font-[600]">
        Activity Details
      </div>
      <div className="text-[#0E0E0E] text-[1.125rem] font-[500] font-dmSans">
        Fill with relevant infomation
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10 mt-[1.5rem]">
        <Form.Item
          name="jaaType"
          className=""
          label={"Choose Activity"}
          rules={[
            {
              required: true,
              message: "Please select activity",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              activityOptions?.length > 0 &&
              activityOptions?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

        <Form.Item
          name="jaaJobId"
          className=""
          label={"Associated Job"}
          rules={[
            {
              required: true,
              message: "Please select associated job",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataJob?.length > 0 &&
              dataJob?.map((item) => ({
                value: item?.jobId,
                label: item?.jobTitle,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </div>
      <Form.Item
        name="jaaTitle"
        label={"Activity Name"}
        rules={[
          {
            required: true,
            message: "Please add activity Name",
          },
        ]}
      >
        <Input className="input" />
      </Form.Item>

      <Form.Item
        name="jaaDesc"
        label={"Description"}
        rules={[
          {
            required: true,
            message: "Please add Description",
          },
        ]}
      >
        <TextArea className="input" />
      </Form.Item>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5 w-full mt-[3.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[230px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
              disabled={saving}
            >
              <span className="flex items-center  gap-x-3 ">
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    {" "}
                    Save And Proceed <img src={svg92} alt="svg92" />
                  </>
                )}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActivityDetails;
